exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/*\r\nReduce the margin under the input so the hint text is grouped closer to the\r\ninput it refers to, instead of being equally spaced between the input it refers\r\nto and the one below it\r\n*/\n.v-input__slot {\r\n  margin-bottom: 3px;\n}\r\n", ""]);

// exports
